module.exports = __webpack_public_path__ + "img/bellow01.74f78206.png";